import { SparklesIcon } from 'lucide-react'
import React from 'react'
import { useRedirect } from '../../Shared/Hooks/useRedirect '
import { CandidateProfile } from '../Types/CandidateType';

interface CandidateDashboardHeaderProps {
  candidate: CandidateProfile | null;
}

// function CandidateDashboardHeader() {


function CandidateDashboardHeader({
  candidate,
}: CandidateDashboardHeaderProps) {
    const redirect = useRedirect();
     const editProfileHandleClick = () => {
    redirect("/candidate/edit-profile");
  };
  return (
    <div>
        <header className="relative mb-10 flex flex-col md:flex-row md:items-center justify-between gap-6 overflow-hidden bg-gradient-to-r from-indigo-900 via-violet-900 to-fuchsia-900 p-6 md:p-8 rounded-2xl border border-white/10 shadow-2xl shadow-indigo-950/40 mt-7">
  <div className="pointer-events-none absolute -top-20 -right-16 h-64 w-64 rounded-full bg-fuchsia-500/25 blur-3xl" />
  <div className="pointer-events-none absolute -bottom-24 -left-10 h-64 w-64 rounded-full bg-cyan-400/20 blur-3xl" />
  <div className="relative text-white">
    <div className="flex items-center gap-3 mb-2">
      <SparklesIcon className="h-7 w-7 text-yellow-400 animate-pulse" />
      <h1 className="text-4xl md:text-5xl font-extrabold uppercase tracking-tight bg-gradient-to-r from-yellow-200 via-pink-400 to-purple-400 bg-clip-text text-transparent">
        Next Generation Talent
      </h1>
    </div>
    <p className="text-indigo-100/90 font-medium text-lg md:pl-1">
    Top Leaders Don't Apply. They Get Invited.
    </p>
  </div>

  <div className="relative w-full max-w-sm rounded-xl bg-white p-4 shadow-xl">
    <div className="flex items-center justify-between mb-2">
      <span className="text-sm font-medium text-gray-700">
        Profile Completion
      </span>

      <span className="text-sm font-bold text-indigo-600">
        {candidate?.profileCompleteScore ?? 0}%
      </span>
    </div>

    <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
      <div
        className="h-full rounded-full bg-gradient-to-r from-cyan-400 via-indigo-500 to-fuchsia-500 transition-all duration-500"
        style={{
          width: `${candidate?.profileCompleteScore ?? 0}%`,
        }}
      />
    </div>

    <button
      onClick={editProfileHandleClick}
      className="mt-3 w-full inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg font-semibold text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-fuchsia-600 hover:brightness-110 transition-all active:scale-95"
    >
      <span className="text-lg">+</span>
      <span>Complete Profile</span>
    </button>
  </div>
</header>
    </div>
  )
}

export default CandidateDashboardHeader